"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableCellValueAssetProperty = exports.resultsTableCellValueAssetPropertyDefinition = void 0;
exports.resultsTableCellValueAssetPropertyDefinition = {
    view: { label: 'Results Table Cell Value Asset' },
    constraints: [
        {
            name: 'stencils',
            argument: ['artist', 'athlete'],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'results-table-cell-value-asset',
};
const isResultsTableCellValueAssetProperty = (prop) => {
    return prop.name === exports.resultsTableCellValueAssetPropertyDefinition.name;
};
exports.isResultsTableCellValueAssetProperty = isResultsTableCellValueAssetProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1jZWxsLXZhbHVlLWFzc2V0LnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcmVzdWx0cy10YWJsZS1jZWxsLXZhbHVlLWFzc2V0LnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNENBQTRDLEdBQUc7SUFDMUQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLGdDQUFnQyxFQUFFO0lBQ2pELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsUUFBUSxFQUFFLFNBQVMsQ0FBQztTQUNoQztLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxnQ0FBZ0M7Q0FDUCxDQUFBO0FBSTFCLE1BQU0sb0NBQW9DLEdBQUcsQ0FBQyxJQUFrQixFQUE4QyxFQUFFO0lBQ3JILE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxvREFBNEMsQ0FBQyxJQUFJLENBQUE7QUFDeEUsQ0FBQyxDQUFBO0FBRlksUUFBQSxvQ0FBb0Msd0NBRWhEIn0=